<template>
  <div>
    <el-dialog
      :visible.sync="this.$root.cargoDetailDialog"
      :before-close="handleClose"
      custom-class="cargo-detail-dialog"
      width="90%"
      top="4vh"
      append-to-body
    >
      <template slot="title">
        <div class="cdd-header">
          <div class="cdd-header__main">
            <span class="cdd-header__label">Ачаа</span>
            <span class="cdd-header__id">#{{ selectedCargoDetail.id }}</span>
          </div>
          <el-tag
            v-if="latestStatusLabel"
            :type="statusTagType(latestStatusCode)"
            size="small"
            effect="dark"
            class="cdd-header__tag"
          >
            {{ latestStatusLabel }}
          </el-tag>
        </div>
      </template>

      <div class="cdd-body">
        <div class="cdd-summary">
          <dl class="cdd-dl">
            <div v-if="selectedCargoDetail.mkub" class="cdd-row">
              <dt>Метр куб</dt>
              <dd>{{ selectedCargoDetail.mkub }}</dd>
            </div>
            <div v-if="checkPermissionsPage('app_cargo_yuan') && selectedCargoDetail.yuan" class="cdd-row">
              <dt>Юань</dt>
              <dd>{{ selectedCargoDetail.yuan | formatCurrencyYuan() }}</dd>
            </div>
            <div v-if="checkPermissionsPage('app_cargo_price') && selectedCargoDetail.price" class="cdd-row">
              <dt>Төгрөг</dt>
              <dd class="cdd-row__emph">{{ selectedCargoDetail.price | formatCurrency() }}</dd>
            </div>
            <div v-if="selectedCargoDetail.count != null && selectedCargoDetail.count !== ''" class="cdd-row">
              <dt>Гаргасан тоо</dt>
              <dd>{{ selectedCargoDetail.count }}</dd>
            </div>
            <div
              v-if="checkPermissionsPage('app_cargo_company') && companyName"
              class="cdd-row"
            >
              <dt>Байгууллага</dt>
              <dd>{{ companyName }}</dd>
            </div>
            <div v-if="checkPermissionsPage('app_cargo_branch') && selectedCargoDetail.branch" class="cdd-row">
              <dt>Салбар</dt>
              <dd>{{ selectedCargoDetail.branch }}</dd>
            </div>
          </dl>

          <div v-if="checkPermissionsPage('app_cargo_payment')" class="cdd-paid">
            <el-tag
              v-if="selectedCargoDetail.is_paid === false"
              type="danger"
              size="small"
              effect="plain"
            >
              Тооцоо хийгээгүй
            </el-tag>
            <el-tag
              v-else-if="selectedCargoDetail.is_paid === true"
              type="success"
              size="small"
              effect="plain"
            >
              Тооцоо хийсэн
            </el-tag>
          </div>
        </div>

        <div class="cdd-section-title">
          <span class="cdd-section-title__text">Төлөвийн түүх</span>
          <span class="cdd-section-title__count" v-if="statusCount">{{ statusCount }}</span>
        </div>

        <div class="cdd-timeline">
          <div
            v-for="(item, index) in selectedCargoDetail.CargoStatus"
            :key="index"
            class="cdd-step"
          >
            <div class="cdd-step__rail" aria-hidden="true">
              <span class="cdd-step__dot" :class="'cdd-step__dot--' + statusAccentClass(item.status)" />
              <span v-if="index < (selectedCargoDetail.CargoStatus || []).length - 1" class="cdd-step__line" />
            </div>
            <el-card class="cdd-step__card br-20" shadow="hover" :body-style="{ padding: '12px 14px' }">
              <div class="cdd-step__head">
                <span class="cdd-step__date" v-if="item.createdAt">{{ item.createdAt.split('T')[0] }}</span>
                <el-tag
                  v-if="item.status"
                  :type="statusTagType(item.status)"
                  size="mini"
                  effect="plain"
                >
                  {{ returnStatusValue(item.status) }}
                </el-tag>
              </div>
              <p v-if="item.description" class="cdd-step__desc">{{ item.description }}</p>
              <p v-if="item.count != null && item.count !== ''" class="cdd-step__meta">
                Хүлээн авсан: <strong>{{ item.count }}</strong>
              </p>
              <p v-if="item.User && item.User.lastName" class="cdd-step__meta">
                Бүртгэсэн: <strong>{{ item.User.lastName }}</strong>
              </p>
              <div v-if="normalizedImages(item.img_path).length" class="cdd-step__images">
                <el-image
                  v-for="(pics, picIndex) in normalizedImages(item.img_path)"
                  :key="picIndex"
                  class="cdd-step__img"
                  :src="imageBase + pics"
                  :preview-src-list="normalizedImages(item.img_path).map(p => imageBase + p)"
                  fit="cover"
                />
              </div>
            </el-card>
          </div>
        </div>

        <el-button
          v-if="checkPermissionsPage('app_cargo_create_cargo_process')"
          type="primary"
          class="cdd-action"
          icon="el-icon-edit-outline"
          @click="crudCargoDetailDialogOpen()"
        >
          Ачааны явц оруулах
        </el-button>
      </div>
    </el-dialog>
    <CrudCargoDetail
      v-if="this.$root.crudCargoDetailDialog"
      :selectedCargoDetailId="this.selectedCargoDetail.id"
    />
  </div>
</template>

<script>
import { checkPermissions } from '@/helpers/custom'
import { mapGetters } from 'vuex'
import CrudCargoDetail from './CrudCargoDetailDialog.vue'

export default {
  data () {
    return {
      hvleenAwsanToo: 0
    }
  },
  props: {
    selectedCargoDetail: {
      type: Object,
      default: () => ({ CargoStatus: [] })
    }
  },
  components: {
    CrudCargoDetail
  },
  computed: {
    ...mapGetters([
      'cdnGetter'
    ]),
    imageBase () {
      return this.cdnGetter || 'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com'
    },
    companyName () {
      const c = this.selectedCargoDetail.Company
      return c && c.company_name ? c.company_name : ''
    },
    statusList () {
      return this.selectedCargoDetail.CargoStatus || []
    },
    statusCount () {
      const n = this.statusList.length
      return n ? `${n} бичлэг` : ''
    },
    latestStatusItem () {
      const list = this.statusList
      if (!list.length) return null
      return list[list.length - 1]
    },
    latestStatusCode () {
      return this.latestStatusItem && this.latestStatusItem.status
    },
    latestStatusLabel () {
      const c = this.latestStatusCode
      return c != null ? this.returnStatusValue(c) : ''
    }
  },
  methods: {
    async crudCargoDetailDialogOpen () {
      this.$root.crudCargoDetailDialog = true
    },
    handleClose (done) {
      this.$root.cargoDetailDialog = false
      if (typeof done === 'function') {
        done()
      }
    },
    normalizedImages (paths) {
      if (!paths) return []
      if (Array.isArray(paths)) return paths.filter(Boolean)
      if (typeof paths === 'string') {
        const t = paths.trim()
        if (!t) return []
        if (t.startsWith('[')) {
          try {
            const p = JSON.parse(t)
            return Array.isArray(p) ? p.filter(Boolean) : [t]
          } catch (e) {
            return [t]
          }
        }
        return [t]
      }
      return []
    },
    returnStatusValue (data) {
      const result = this.$root.cargoStatus.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    statusTagType (status) {
      const map = {
        130: 'success',
        100: 'primary',
        110: 'warning',
        140: 'danger'
      }
      return map[status] || 'info'
    },
    statusAccentClass (status) {
      const map = {
        130: 'success',
        100: 'primary',
        110: 'warning',
        140: 'danger'
      }
      return map[status] || 'muted'
    }
  }
}
</script>

<style>
.cargo-detail-dialog {
  border-radius: 16px !important;
  overflow: hidden;
  max-width: 440px;
}

.cargo-detail-dialog .el-dialog__header {
  padding: 16px 18px 12px;
  background: linear-gradient(135deg, #f0f4f8 0%, #e8eef5 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
}

.cargo-detail-dialog .el-dialog__title {
  width: 100%;
}

.cargo-detail-dialog .el-dialog__body {
  padding: 0 0 18px;
  max-height: 72vh;
  overflow-y: auto;
  background: #f8fafc;
}

.cargo-detail-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 12px;
}
</style>

<style scoped>
.cdd-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-right: 28px;
}

.cdd-header__main {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.cdd-header__label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.cdd-header__id {
  font-size: 1.35rem;
  font-weight: 500;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.cdd-header__tag {
  flex-shrink: 0;
  border-radius: 8px !important;
}

.cdd-body {
  padding: 14px 16px 0;
}

.cdd-summary {
  background: #fff;
  border-radius: 14px;
  padding: 14px 16px;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
  margin-bottom: 16px;
}

.cdd-dl {
  margin: 0;
}

.cdd-row {
  display: grid;
  grid-template-columns: minmax(96px, 36%) 1fr;
  gap: 6px 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.cdd-row:last-of-type {
  border-bottom: none;
}

.cdd-row dt {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
}

.cdd-row dd {
  margin: 0;
  font-size: 14px;
  color: #334155;
  word-break: break-word;
}

.cdd-row__emph {
  font-weight: 500;
  color: #0f172a !important;
}

.cdd-paid {
  margin-top: 12px;
  padding-top: 10px;
  border-top: 1px dashed #e2e8f0;
}

.cdd-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 0 2px;
}

.cdd-section-title__text {
  font-size: 13px;
  font-weight: 500;
  color: #475569;
}

.cdd-section-title__count {
  font-size: 11px;
  color: #94a3b8;
}

.cdd-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.cdd-step {
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.cdd-step__rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 18px;
  flex-shrink: 0;
  padding-top: 18px;
}

.cdd-step__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 2px solid #fff;
  box-shadow: 0 0 0 2px rgba(148, 163, 184, 0.5);
}

.cdd-step__dot--success {
  background: #67c23a;
  box-shadow: 0 0 0 2px rgba(103, 194, 58, 0.35);
}

.cdd-step__dot--primary {
  background: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.35);
}

.cdd-step__dot--warning {
  background: #e6a23c;
  box-shadow: 0 0 0 2px rgba(230, 162, 60, 0.35);
}

.cdd-step__dot--danger {
  background: #f56c6c;
  box-shadow: 0 0 0 2px rgba(245, 108, 108, 0.35);
}

.cdd-step__dot--muted {
  background: #94a3b8;
}

.cdd-step__line {
  flex: 1;
  width: 2px;
  min-height: 12px;
  margin: 4px 0 0;
  background: linear-gradient(180deg, #cbd5e1, #e2e8f0);
  border-radius: 1px;
}

.cdd-step__card {
  flex: 1;
  margin-bottom: 12px;
  border: 1px solid rgba(226, 232, 240, 0.9) !important;
}

.cdd-step__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.cdd-step__date {
  font-size: 13px;
  font-weight: 500;
  color: #0f172a;
}

.cdd-step__desc {
  margin: 0 0 8px;
  font-size: 13px;
  line-height: 1.5;
  color: #475569;
}

.cdd-step__meta {
  margin: 0 0 6px;
  font-size: 12px;
  color: #64748b;
}

.cdd-step__images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}

.cdd-step__img {
  width: 88px;
  height: 88px;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.cdd-action {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 4px;
  border-radius: 12px !important;
}
</style>
